import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { SystemeModule } from '../systeme.module';
import { InstitutionFormComponent } from './institution-form/institution-form.component';

@NgModule({
	declarations: [
		InstitutionFormComponent,
	],
	imports: [SharedModule, SystemeModule]
})
export class InstitutionsModule {}
